import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
    campaignFacebookAccounts,
    campaignFacebookLeadgenForms,
    checkCampaignFacebookLeadSetup,
    checkFacebookLeadSetup,
    checkFacebookSetup,
    disconnectFacebook,
    facebookAccounts,
    facebookLeadgenForms,
    redirectFacebook,
} from './api'
import { onErrorNotifyAboutValidationError } from '../util'

export function useRedirectFacebook() {
    return useMutation({
        mutationFn: redirectFacebook,
    })
}

export function useDisconnectFacebook() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: disconnectFacebook,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['me'] })
        },
    })
}

export function useCheckFacebookSetup() {
    return useMutation({
        mutationFn: checkFacebookSetup,
        onError: onErrorNotifyAboutValidationError,
    })
}

export function useFacebookAccounts() {
    return useQuery({
        queryFn: () => facebookAccounts().catch(onErrorNotifyAboutValidationError),
        queryKey: ['facebook-accounts'],
    })
}

export function useFacebookLeadgenForms(accountId?: string | null) {
    return useQuery({
        queryFn: () => facebookLeadgenForms(accountId!).catch(onErrorNotifyAboutValidationError),
        queryKey: ['leadgen-forms', accountId],
        enabled: !!accountId,
    })
}

export function useCampaignFacebookAccounts(campaignId?: string | null) {
    return useQuery({
        queryFn: () => campaignFacebookAccounts(campaignId!).catch(onErrorNotifyAboutValidationError),
        queryKey: ['campaigns', campaignId, 'facebook-accounts'],
        enabled: !!campaignId,
    })
}

export function useCampaignFacebookLeadgenForms(campaignId?: string | null, accountId?: string | null) {
    return useQuery({
        queryFn: () => campaignFacebookLeadgenForms(campaignId!, accountId!).catch(onErrorNotifyAboutValidationError),
        queryKey: ['campaigns', campaignId, 'leadgen-forms', accountId],
        enabled: !!campaignId && !!accountId,
    })
}

export function useCheckCampaignFacebookLeadSetup(campaignId: string) {
    return useMutation({
        mutationFn: (data: { accountId?: string; formId?: string }) => checkCampaignFacebookLeadSetup(campaignId, data),
        onError: onErrorNotifyAboutValidationError,
    })
}

export function useCheckFacebookLeadSetup() {
    return useMutation({
        mutationFn: (data: { accountId?: string; formId?: string }) => checkFacebookLeadSetup(data),
        onError: onErrorNotifyAboutValidationError,
    })
}
